// src/design-system/Gauge.tsx
import { TONE_FG, type Tone } from "./tone";

const R = 80;
const ARC = Math.PI * R; // طول نصف الدائرة
const polar = (deg: number, r: number) => [100 + r * Math.cos((deg * Math.PI) / 180), 100 - r * Math.sin((deg * Math.PI) / 180)] as const;

export type Zone = { to: number; tone: Tone };

/** مؤشر نصف دائري بإبرة وأقواس مضيئة للمناطق؛ الإبرة تتحرك حسب القيمة ضمن [0, max]. */
export function Gauge({ value, max = 30, zones }: { value: number; max?: number; zones: Zone[] }) {
  const clamped = Math.max(0, Math.min(value, max));
  const deg = 180 * (1 - clamped / max);
  const [nx, ny] = polar(deg, 62);
  const [mx, my] = polar(deg, R);
  const current = zones.find((z) => clamped <= z.to) ?? zones[zones.length - 1];
  let start = 0;
  return (
    <svg viewBox="0 0 200 116" width={220} role="img" aria-label={`المؤشر عند ${value}`} style={{ flex: "none" }}>
      <path d="M20,100 A80,80 0 0 1 180,100" fill="none" stroke="rgba(148,180,214,.14)" strokeWidth={14} strokeLinecap="round" />
      {zones.map((z, i) => {
        const len = ((z.to - start) / max) * ARC;
        const offset = -(start / max) * ARC;
        start = z.to;
        const c = TONE_FG[z.tone];
        return (
          <path key={i} d="M20,100 A80,80 0 0 1 180,100" fill="none" stroke={c} strokeWidth={14}
            strokeLinecap={i === 1 ? "butt" : "round"} strokeDasharray={`${Math.max(0, len - 4)} ${ARC * 2}`} strokeDashoffset={offset}
            style={{ filter: `drop-shadow(0 0 8px ${c}bb)` }} />
        );
      })}
      <line x1={100} y1={100} x2={nx} y2={ny} stroke="#F5E4C0" strokeWidth={3} strokeLinecap="round" style={{ filter: "drop-shadow(0 0 7px rgba(245,228,192,.9))" }} />
      <circle cx={100} cy={100} r={7} fill="#F5E4C0" style={{ filter: "drop-shadow(0 0 10px rgba(214,172,85,.9))" }} />
      <circle cx={mx} cy={my} r={5} fill={TONE_FG[current.tone]} style={{ filter: `drop-shadow(0 0 12px ${TONE_FG[current.tone]})` }} />
    </svg>
  );
}
